import config from 'config';
import { KATANA_PERPS } from 'config/constants';

import { metaTagsStaticProd } from './metaTagsStatic';

export const metaTagsDefaults = {
  mainTitle: metaTagsStaticProd.mainTitle,
  emptyTitle:
    config.env === 'sandbox'
      ? `${KATANA_PERPS} Sandbox | Katana's Native Perpetuals DEX`
      : metaTagsStaticProd.emptyTitle, // Set in index.html
  description: metaTagsStaticProd.description,
};
